import Button from 'components/button/Button';
import cx from 'classnames';
import { Carousel } from 'components/carousel/Carousel';
import { isEqualVal } from 'helpers/string.helper';
import { map, range, slice } from 'lodash';
import { DList } from 'models/common.model';
import React from 'react';

type EditPhotoSelectCategoryProps = {
  selectedCatId?: number;
  catPerPage: number;
  listCatData: DList<any> | null;
  onSelectCategory?: (id: number) => void;
};

const EditPhotoSelectCategory: React.FC<EditPhotoSelectCategoryProps> = ({
  selectedCatId,
  catPerPage,
  listCatData,
  onSelectCategory,
}) => (
  <div className="text-center edit-photo__category-carousel--wrapper">
    <Carousel
      className="edit-page__edit-category-carousel"
      hiddenDot
      hiddenBtn={false}
      slides={range(
        1,
        Math.ceil((listCatData?.totalRecord || 0) / catPerPage) + 1,
      )}
      RenderSlide={(_, ind) => (
        <div className="edit-page__edit-category-button-group">
          {map(
            slice(listCatData?.data, ind * catPerPage, (ind + 1) * catPerPage),
            (category) => {
              const isCateActive = isEqualVal(selectedCatId, category?.id);

              return (
                <Button
                  key={category?.id}
                  color="primary"
                  onClick={() => onSelectCategory?.(category?.id)}
                  className={cx('category-button', {
                    active: isCateActive,
                  })}
                  noBorder={!isCateActive}
                  TypographyProps={{
                    className: 'text-ellipsis overflow-hidden',
                  }}
                >
                  {category?.name}
                </Button>
              );
            },
          )}
        </div>
      )}
    />
  </div>
);
export default EditPhotoSelectCategory;
